import * as THREE from './src/three.module.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';

import Stats from './src/stats.module.js';
// import {GUI} from './src/dat.gui.module.js';

import {OrbitControls} from './src/OrbitControls.js';
import { gravity, restDistanceX, restDistanceY, segmentsCountX, segmentsCountY, textures, TIMESTEP_SQ } from './src/contstants.js';
import {loadNextTexture, loadTextureByUrls, plane, satisfyConstraints} from "./src/utils.js";
import {Cloth} from "./src/cloth.js";
import controlsHtml from './controls.html';
import {
    createRuler,
    getIsActiveRuler,
    setIsActiveRuler,
    updateDelimiters,
    updateRulerSize
} from "./src/component/ruler/ruler";
import {HORIZONTAL_RULER, VERTICAL_RULER} from "./src/component/ruler/consts";
import { createLightController, getIsActiveLight, setIsActiveLight } from './src/component/light/light';

var params = {
    enableWind: true,
    loadNextTexture: () =>  {
        const { material, geometry, object } = loadNextTexture(currentTextureIndex, cloth, clothFunction);
        if (currentTextureIndex + 1 < textures.length) {
            currentTextureIndex++;
        } else {
            currentTextureIndex = 0;
        }
        clothMaterial = material;
        clothGeometry = geometry;
        if (clothObject) {
            scene.remove(clothObject);
        }
        clothObject = object;
        scene.add(clothObject);
    },
    windStrengthFactor: 40,
    foldsFactor: 0,
};
let xSegs = segmentsCountX;
const ySegs = segmentsCountY;
let clothFunction = plane(restDistanceX * xSegs, restDistanceY * ySegs);
let foldsFactor = 0;
let cloth = new Cloth(xSegs, ySegs, foldsFactor, clothFunction, 0);
let pins = [];
const windForce = new THREE.Vector3(0, 0, 0);
const tmpForce = new THREE.Vector3();
let windStrengthFactor = 40;
let clothMaterial;

function simulate(now) {

    const windStrength = Math.cos(now / 7000) * 20 + windStrengthFactor;

    windForce.set(Math.sin(now / 2000), Math.cos(now / 3000), Math.sin(now / 1000));
    windForce.normalize();
    windForce.multiplyScalar(windStrength);

    let i, j, il, particles, particle, constraints, constraint;

    // Aerodynamics forces

    if (params.enableWind) {
        let index;
        let normal = new THREE.Vector3();
        let indices = clothGeometry.index;
        let normals = clothGeometry.attributes.normal;

        particles = cloth.particles;

        for (i = 0, il = indices.count; i < il; i += 3) {
            for (j = 0; j < 3; j++) {
                index = indices.getX(i + j);
                normal.fromBufferAttribute(normals, index);
                tmpForce.copy(normal).normalize().multiplyScalar(normal.dot(windForce));
                particles[index].addForce(tmpForce);
            }
        }
    }

    for (particles = cloth.particles, i = 0, il = particles.length; i < il; i++) {
        particle = particles[i];
        particle.addForce(gravity);
        particle.integrate(TIMESTEP_SQ);
    }

    // Start Constraints

    constraints = cloth.constraints;

    // Pin Constraints

    for (i = 0, il = pins.length; i < il; i++) {
        let xy = pins[i];
        let p = particles[xy];
        p.pinned = true;
        p.position.copy(p.original);
        p.previous.copy(p.original);
    }

    // Repeat satisfy to prevent stretch of particles
    for (let cicle = 0; cicle < 10; cicle++) {
        for (i = 0, il = constraints.length; i < il; i++) {
            constraint = constraints[i];
            satisfyConstraints(constraint[0], constraint[1], constraint[2], i);
        }
    }

    // Floor Constraints

    for (particles = cloth.particles, i = 0, il = particles.length; i < il; i++) {
        particle = particles[i];
    }

}

/* testing cloth simulation */

for (let i = 0; i < segmentsCountX + 1; i++) {
    pins.push(i);
}

let container, stats;
let camera, scene, renderer;

let clothGeometry;
let clothObject;
let cubeObject;
let materialObject;
let showCubeObject = false;

let loader = new THREE.TextureLoader();

let orbitControls;

// cloth material
let currentTextureIndex = 0;

function reCreateClothOrCube(newClothObject) {
    if (clothObject) {
        scene.remove(clothObject);
    }
    if (cubeObject) {
        scene.remove(cubeObject);
    }
    if (newClothObject) {
        clothObject = newClothObject;
    }
    if (!scene) {
        return;
    }
    if (showCubeObject) {
        cubeObject = new THREE.Mesh( new THREE.BoxGeometry( 200, 200, 200 ), materialObject);
        cubeObject.castShadow = true;
        scene.add(cubeObject);
    } else {
        scene.add(clothObject);
    }
}

function updateCanvasSize() {
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    camera.aspect = width / height;
    updateRulerSize(container, width, height);
    updateDelimiters(orbitControls);
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
    if (document.fullscreenEnabled ||
        document.mozFullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.msFullscreenEnabled)
    {
        // fullscreenInput.style.display = 'block';
        // fullscreenInputExit.style.display = 'none';
    }
}

function render() {
    let p = cloth.particles;

    for (let i = 0, il = p.length; i < il; i++) {
        let v = p[i].position;
        clothGeometry.attributes.position.setXYZ(i, v.x, v.y, v.z);
    }

    clothGeometry.attributes.position.needsUpdate = true;
    clothGeometry.computeVertexNormals();
    renderer.render(scene, camera);
}


const loadTexture = (textureMaps) => {
    const {material, geometry, object} = loadTextureByUrls(textureMaps, cloth, clothFunction);
    materialObject = material;

    if (currentTextureIndex + 1 < textures.length) {
        currentTextureIndex++;
    } else {
        currentTextureIndex = 0;
    }
    clothMaterial = material;
    clothGeometry = geometry;

    reCreateClothOrCube(object);
};


const TurnicWidget = function () {
    this.animate = (now) => {
        this.animationFrameId = requestAnimationFrame(this.animate);
        simulate(now);
        render();
        stats.update();
    };

    this.run = (containerId, options) => {
        this.containerId = containerId;

        // container = document.createElement('div');
        container = document.getElementById(containerId);
        container.style.position = 'relative';

        // scene
        scene = new THREE.Scene();
        let backgroundColor = (typeof options.backgroundColor) == 'string' ? parseInt(options.backgroundColor) :  options.backgroundColor;
        backgroundColor = backgroundColor == null ? 0xcce0ff : backgroundColor;
        scene.background = new THREE.Color(backgroundColor);
        scene.fog = new THREE.Fog(backgroundColor, 500, 10000);

        // camera
        camera = new THREE.PerspectiveCamera(20, window.innerWidth / window.innerHeight, 1, 10000);
        camera.position.set(0, 300, -1100);

        // lights
        scene.add(new THREE.AmbientLight(0x999999));

        let light = new THREE.DirectionalLight(0xffffff, 1);
        light.position.set(0, 90, 60);

        light.castShadow = true;

        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;

        let d = 300;

        light.shadow.camera.left = -d;
        light.shadow.camera.right = d;
        light.shadow.camera.top = d;
        light.shadow.camera.bottom = -d;

        light.shadow.camera.far = 1000;

        scene.add(light);

        // cloth material
        loadTexture(options.textures);

        // ground
        let groundTexture = loader.load(options.groundTexture);
        groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
        groundTexture.repeat.set(25, 25);
        groundTexture.anisotropy = 16;
        groundTexture.encoding = THREE.sRGBEncoding;

        let groundMaterial = new THREE.MeshLambertMaterial({map: groundTexture});

        let mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(20000, 20000), groundMaterial);
        mesh.position.y = -250;
        mesh.rotation.x = -Math.PI / 2;
        mesh.receiveShadow = true;
        scene.add(mesh);

        // renderer
        renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(container.offsetWidth, container.offsetHeight);
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();

        container.appendChild(renderer.domElement);

        renderer.toneMapping = options.toneMapping || THREE.NoToneMapping;
        renderer.toneMappingExposure = options.toneMappingExposure || 1;
        //renderer.outputEncoding = THREE.sRGBEncoding;

        renderer.shadowMap.enabled = true;

        // controls
        let controls = new OrbitControls(camera, renderer.domElement);
        orbitControls = controls;
        controls.maxPolarAngle = Math.PI * 0.5;
        controls.minDistance = 200;
        controls.maxDistance = 5000;

        // performance monitor
        stats = new Stats();
        // container.appendChild(stats.dom);

        window.addEventListener('resize', updateCanvasSize, false);

        //creating controls
        const divContainer = document.createElement('div');
        divContainer.style.position = 'absolute';
        divContainer.style.left = '0';
        divContainer.style.right = '0';
        divContainer.style.height = '52px';
        divContainer.style.bottom = '-4px';
        divContainer.style.border = '1px solid #D8D7D7';
        divContainer.style.backgroundColor = 'white';
        divContainer.style.display = 'flex';
        divContainer.innerHTML = controlsHtml;
        container.appendChild(divContainer);


        const windInput = container.querySelector('.crossbar-widget-wind-input');
        windInput.oninput = () => {
            const value = parseInt(windInput.value);
            windStrengthFactor = value * 50 * (1 / (options.weight / 50));
            params.enableWind = !!windStrengthFactor;
        };
        windInput.oninput();
        const foldsDisplayInput = container.querySelector('.crossbar-widget-folds-display');
        const foldsDisplay = container.querySelector('.crossbar-widget-folds');
        foldsDisplay.oninput = () => {
            const value = parseInt(foldsDisplay.value);
            foldsFactor = value > 3 ? (value - 3) : 0;
            if (foldsDisplayInput) {
                foldsDisplayInput.value = value;
            }

            // + foldsFactor > 4 ? (foldsFactor - 4)*4 : 0
            //segmentsCount * foldsFactor
            xSegs = 2 * Math.round((segmentsCountX + 4 * foldsFactor) / 2);
            clothFunction = plane(restDistanceX * xSegs, restDistanceY * ySegs);
            cloth = new Cloth(xSegs, ySegs, foldsFactor, clothFunction, value);
            xSegs = 2 * Math.round(xSegs * 175 / cloth.realW / 2);
            clothFunction = plane(restDistanceX * xSegs, restDistanceY * ySegs);
            cloth = new Cloth(xSegs, ySegs, foldsFactor, clothFunction, value);
            clothGeometry = new THREE.ParametricBufferGeometry(clothFunction, cloth.w, cloth.h);

            const object = new THREE.Mesh(clothGeometry, clothMaterial);
            object.position.set(0, 0, 0);
            object.castShadow = true;
            object.receiveShadow = false;
            object.renderOrder = 3;
            reCreateClothOrCube(object);
            pins = [];
            for (let i = 0; i < xSegs + 1; i++) {
                pins.push(i);
            }
        };
        foldsDisplay.oninput();

        const fullscreenInput = container.querySelector('.crossbar-widget-fullscreen');
        container.appendChild(fullscreenInput);
        const rulerInput = container.querySelector('.ruler-wrapper');
        const rulerIcon = container.querySelector('.ruler-icon');
        const rulerPoint = container.querySelector('.ruler-point');
        const lightInput = container.querySelector('.light-wrapper');
        const lightIcon = container.querySelector('.light-icon');
        const lightIconActive = container.querySelector('.light-icon-active');
        fullscreenInput.onclick = () => {
            if (container.requestFullscreen) {
                container.requestFullscreen();
            } else if (container.mozRequestFullScreen) {
                container.mozRequestFullScreen();
            } else if (container.webkitRequestFullscreen) {
                container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (container.msRequestFullscreen) {
                container.msRequestFullscreen();
            }
            fullscreenInput.style.display = 'none';
            fullscreenInputExit.style.display = 'block';
            let horizontalRuler = document.getElementById(HORIZONTAL_RULER);
            let verticalRuler = document.getElementById(VERTICAL_RULER);
            if (getIsActiveRuler()) {
                rulerInput.style.backgroundColor = '#632525';
                rulerIcon.style.fill = '#ffffff';
                horizontalRuler.style.display = 'block';
                verticalRuler.style.display = 'block';
            } else {
                rulerInput.style.backgroundColor = 'transparent';
                rulerIcon.style.fill = '#632525';
            }
            updateCanvasSize();
        };
        container.appendChild(rulerInput);
        rulerInput.addEventListener('click',function(){
            let horizontalRuler = document.getElementById(HORIZONTAL_RULER);
            let verticalRuler = document.getElementById(VERTICAL_RULER);
            if (horizontalRuler.style.display === 'none'  && verticalRuler.style.display ==='none') {
                rulerInput.style.backgroundColor = '#632525';
                rulerIcon.style.fill = '#ffffff';
                rulerPoint.style.color = '#ffffff';
                horizontalRuler.style.display = 'block';
                verticalRuler.style.display = 'block';
                setIsActiveRuler(true);
            } else {
                horizontalRuler.style.display = 'none';
                verticalRuler.style.display = 'none';
                rulerInput.style.backgroundColor = 'transparent';
                rulerIcon.style.fill = '#632525';
                rulerPoint.style.color = '#632525';
                setIsActiveRuler(false);
            }
        });
        lightInput.addEventListener('click',function(){
          if (getIsActiveLight()) {
            lightIcon.style.display = 'block';
            lightIconActive.style.display = 'none';
            setIsActiveLight(false);
          } else {
            lightIcon.style.display = 'none';
            lightIconActive.style.display = 'block';
            setIsActiveLight(true);
          }
        });
        const fullscreenInputExit = container.querySelector('.crossbar-widget-fullscreen-exit');
        container.appendChild(fullscreenInputExit);
        fullscreenInputExit.onclick = () => {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            fullscreenInput.style.display = 'block';
            fullscreenInputExit.style.display = 'none';
            let horizontalRuler = document.getElementById(HORIZONTAL_RULER);
            let verticalRuler = document.getElementById(VERTICAL_RULER);
            let isActiveRuler = getIsActiveRuler();
            if (isActiveRuler) {
                rulerInput.style.backgroundColor = '#632525';
                rulerIcon.style.fill = '#ffffff';
                horizontalRuler.style.display = 'block';
                verticalRuler.style.display = 'block';
            } else {
                rulerInput.style.backgroundColor = 'transparent';
                rulerIcon.style.fill = '#632525';
            }
            updateCanvasSize();
        };

        const windLabel = container.querySelector('.crossbar-widget-wind-label');
        if (windLabel && options.textWindLabel) {
            windLabel.innerText = options.textWindLabel;
        }

        const foldsLabel = container.querySelector('.crossbar-widget-folds-label');
        if (foldsLabel && options.textFoldsLabel) {
            console.log(options);
            console.log(options.textFoldsLabel);
            foldsLabel.innerText = options.textFoldsLabel;
            console.log(foldsLabel.innerText);
        }

        this.animate(0);
        createRuler(container);

        container.appendChild(lightInput);
        createLightController(container, light, options);
    };

    this.destroy = () => {
        cancelAnimationFrame(this.animationFrameId);
        const container = document.getElementById(this.containerId);
        if (container) {
            container.innerHTML = '';
        }
    };

    this.updateCanvasSize = () => {
        updateCanvasSize();
    };

    this.showCube = (show) => {
        showCubeObject = show;
        reCreateClothOrCube();
    }
};

export function getControls() {
    return orbitControls;
}

export function getCamera() {
    return camera;
}

window.TurnicWidget = TurnicWidget;
